import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Link } from 'formlabs-web-components/Link';
import { Picture } from 'formlabs-web-components/Media';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';
import { GridContainer, Grid, Cell } from 'formlabs-web-components/Grid';
import debounce from 'lodash/debounce';
import { compose } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Helmet } from 'react-helmet';
import { useQuery } from '@apollo/client';

import CountryContext from '../../context/country';
import StoreButton from '../storefront/MenuButton';
import ContactSales from '../content/ContactSales';
import Cart from '../storefront/Cart';
import MenuSignIn from './MenuSignIn';
import MenuItem from './MenuItem';
import DescriptionDropdown from './DescriptionDropdown';
import ImageGridDropdown from './ImageGridDropdown';
import Dropdown from './Dropdown';
import StickyNav from './StickyNav';
import PageSubNav from './PageSubNav';
import SiteSelector from './SiteSelector';
import RegionFlag from './RegionFlag';
import { CountrySelectionModal } from '../../../sites/formlabs/components/countrySelection/CountrySelection';

import logoBlack from '../../../../public/logo_black.svg';
import logoWhite from '../../../../public/logo_white.svg';

import query from './menu.graphql';
import './HeaderMenu.module.css';

const preventDefaultHandler = event => {
  event.preventDefault();
};

const pickLogo = color => {
  const logos = {
    black: logoBlack,
    white: logoWhite
  };

  if (logos[color]) return logos[color];
  return logos['black'];
};

class HeaderMenuComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hoverOptions: -1,
      mobile: false,
      stickyNav: false,
      mediumSize: false,
      dropdownOpen: false,
      siteSelect: {
        hover: false,
        open: false
      }
    };
    this.child = React.createRef();
    this.containerRef = React.createRef();
  }

  static contextType = CountryContext;

  handleScrollStickyNav = () => {
    this.setState(
      {
        stickyNav: window.scrollY >= 80 && !this.state.mobile
      },
      () => {
        if (this.state.stickyNav && this.state.dropdownOpen) {
          this.handleHoverMenuClose();
        }
      }
    );
  };

  debouncedStickyNav = debounce(this.handleScrollStickyNav, 200);

  handleHoverMenu = i => {
    this.setState({
      hoverOptions: i,
      dropdownOpen: true,
      siteSelect: { hover: false, open: false }
    });
  };

  handleHoverSiteSelect = () => {
    this.setState({ siteSelect: { hover: true } });
  };
  handleClickSiteSelect = () => {
    this.setState({
      siteSelect: { hover: true, open: !this.state.siteSelect.open },
      hoverOptions: -1,
      dropdownOpen: false
    });
  };

  handleHoverMenuClose = () => {
    this.setState({
      dropdownOpen: false,
      siteSelect: { hover: false, open: false }
    });
  };

  componentDidMount() {
    window.addEventListener('resize', this.debouncedResize);
    window.addEventListener('scroll', this.debouncedStickyNav);
    window.dispatchEvent(new Event('resize'));
    this.handleScrollStickyNav();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResize);
    window.removeEventListener('scroll', this.debouncedStickyNav);
  }

  resize = () => {
    this.setState({
      mobile: window.innerWidth <= 1050,
      mediumSize: window.innerWidth > 1050 && window.innerWidth <= 1140
    });
  };

  debouncedResize = debounce(this.resize, 100);

  UNSAFE_componentWillReceiveProps(newProps) {
    const oldProps = this.props;
    if (oldProps.slug !== newProps.slug) {
      this.handleHoverMenuClose();
    }
  }

  render() {
    const {
      typeColor,
      data = [],
      additionalHeaderMenu = [],
      secondaryMenu,
      slug,
      countrySite,
      t,
      stickyNavShown,
      isAuthenticated,
      countries,
      activeRegion
    } = this.props;
    const {
      stickyNav,
      mobile,
      hoverOptions,
      dropdownOpen,
      siteSelect,
      mediumSize
    } = this.state;
    const { path, storePage } = this.context;
    const { hover, open } = siteSelect;
    const sites = [
      {
        name: 'Formlabs',
        url: 'https://formlabs.com',
        displayUrl: 'formlabs.com'
      },
      {
        name: 'Dental',
        url: 'https://dental.formlabs.com',
        displayUrl: 'dental.formlabs.com'
      }
    ];
    const isDental = process.env.RAZZLE_CMS_SITE === 'dental';
    const menuItemsLength = data.length + additionalHeaderMenu.length;
    const isRU = countrySite.path === '/ru/';
    const currentPath = get(slug, 'pathname', '');

    return (
      <Fragment>
        <div
          styleName={`header ${dropdownOpen ? 'black ' : typeColor} ${
            dropdownOpen && data[hoverOptions].children.length < 1
              ? 'white-bg'
              : ''
          }`}
          role="navigation"
        >
          <GridContainer>
            <div styleName="static-header" ref={this.containerRef}>
              {!mobile && (
                <Fragment>
                  <div styleName="left-menu">
                    <Link to={path}>
                      <Picture
                        largeImage={pickLogo(
                          dropdownOpen ? 'black' : typeColor
                        )}
                        lazyload={false}
                        alt={t('Formlabs Logo')}
                      />
                    </Link>
                    {isDental && (
                      <SiteSelector
                        open={open}
                        sites={sites}
                        handleHoverSiteSelect={this.handleHoverSiteSelect}
                        handleClickSiteSelect={this.handleClickSiteSelect}
                      />
                    )}
                    <div styleName="main-menu">
                      {data.map((menuItem, i) => {
                        return (
                          <MenuItem
                            key={i}
                            hoverOptions={hoverOptions}
                            itemIndex={i}
                            dropdownOpen={dropdownOpen}
                            menuItem={menuItem}
                            handleHoverMenu={this.handleHoverMenu}
                            itemType={'left'}
                          />
                        );
                      })}
                      {mediumSize &&
                        additionalHeaderMenu.map((menuItem, i) => {
                          return (
                            <MenuItem
                              key={i}
                              hoverOptions={hoverOptions}
                              itemIndex={i + data.length}
                              dropdownOpen={dropdownOpen}
                              menuItem={menuItem}
                              handleHoverMenu={this.handleHoverMenu}
                              itemType={'right'}
                            />
                          );
                        })}
                      {mediumSize && (
                        <MenuItem
                          hoverOptions={hoverOptions}
                          itemIndex={menuItemsLength + 1}
                          dropdownOpen={dropdownOpen}
                          typeColor={typeColor}
                          itemType={'MenuSignIn'}
                        />
                      )}
                      {mediumSize && (
                        <MenuItem
                          hoverOptions={hoverOptions}
                          itemIndex={menuItemsLength + 2}
                          dropdownOpen={dropdownOpen}
                          itemType={'StoreButton'}
                          storePage={storePage}
                        />
                      )}
                      {mediumSize && !storePage && !isRU && (
                        <div
                          styleName={'main-menu-item-contact'}
                          key={`main-menu-div-${menuItemsLength + 3}`}
                        >
                          <ContactSales
                            linkText={t('Contact')}
                            displayType={'button'}
                            buttonColor={'dark'}
                            path={currentPath}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {!mediumSize && (
                    <div
                      styleName="right-menu"
                      onMouseEnter={this.handleHoverMenuClose}
                      role="menu"
                      tabIndex="0"
                    >
                      <div>
                        {additionalHeaderMenu.map(menuItem => {
                          return (
                            <Link
                              to={menuItem.url}
                              styleName="top-level-menu"
                              key={`${menuItem.url} ${menuItem.name}`}
                            >
                              {menuItem.name}
                            </Link>
                          );
                        })}
                      </div>
                      <div styleName="menu-sign-in">
                        <MenuSignIn
                          typeColor={dropdownOpen ? 'black' : typeColor}
                        />
                      </div>
                      {storePage && (
                        <StoreButton
                          color={dropdownOpen ? 'black' : typeColor}
                        />
                      )}
                      {!storePage && !isRU && (
                        <ContactSales
                          linkText={t('Contact Sales')}
                          displayType={'button'}
                          buttonColor={'dark'}
                          path={currentPath}
                        />
                      )}
                    </div>
                  )}
                </Fragment>
              )}
              {mobile && (
                <MobileHeaderMenu
                  typeColor={typeColor}
                  data={data}
                  countrySite={countrySite}
                  t={t}
                  slug={slug}
                  isAuthenticated={isAuthenticated}
                  white={isDental}
                  sites={sites}
                  isDental={isDental}
                  countries={countries}
                  activeRegion={activeRegion}
                />
              )}
            </div>
          </GridContainer>
        </div>
        {!mobile &&
          hoverOptions >= 0 &&
          data[hoverOptions].menuStyle === 'default' && (
            <Dropdown
              hoverOptions={hoverOptions}
              dropdownOpen={dropdownOpen}
              handleHoverMenuClose={this.handleHoverMenuClose}
              ref={this.child}
              data={data}
            />
          )}
        {!mobile &&
          hoverOptions >= 0 &&
          data[hoverOptions].menuStyle === 'image-grid' && (
            <ImageGridDropdown
              hoverOptions={hoverOptions}
              dropdownOpen={dropdownOpen}
              handleHoverMenuClose={this.handleHoverMenuClose}
              ref={this.child}
              data={data}
            />
          )}
        {!mobile &&
          hoverOptions >= 0 &&
          data[hoverOptions].menuStyle === 'description' && (
            <DescriptionDropdown
              hoverOptions={hoverOptions}
              dropdownOpen={dropdownOpen}
              handleHoverMenuClose={this.handleHoverMenuClose}
              ref={this.child}
              data={data}
            />
          )}
        {stickyNavShown && (
          <StickyNav
            stuck={stickyNav}
            secondaryMenu={secondaryMenu}
            slug={slug}
            countrySite={countrySite}
          />
        )}
        <GridContainer>
          {secondaryMenu && (
            <div styleName="page-sub-nav-outer-container">
              <PageSubNav
                secondaryMenu={secondaryMenu}
                stuck={stickyNav}
                slug={slug}
                typeColor={typeColor}
                mobile={mobile}
              />
            </div>
          )}
        </GridContainer>
        <div
          styleName={`overlay selector-overlay open-${hover}`}
          onMouseEnter={this.handleHoverMenuClose}
        />
      </Fragment>
    );
  }
}

const HeaderMenu = ({ countrySite, draft, ...props }) => {
  const { data } = useQuery(query, {
    variables: { draft, path: get(countrySite, 'path', '/'), kind: 'HEAD' }
  });

  const { data: rightMenuData } = useQuery(query, {
    variables: { draft, path: get(countrySite, 'path', '/'), kind: 'RIGHT' }
  });

  const menu = get(data, 'menu', null);
  const additionalHeaderMenu = get(rightMenuData, 'menu', []);

  if (!menu) {
    return null;
  }

  return (
    <HeaderMenuComponent
      {...{ ...props, countrySite, draft, additionalHeaderMenu, data: menu }}
    />
  );
};

export default compose(
  connect(state => {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      activeRegion: state.i18n.region
    };
  }),
  withTranslation()
)(HeaderMenu);

class MobileHeaderMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      cartOpen: false,
      selected: -1,
      siteSelect: {
        hover: false,
        selectOpen: false
      }
    };
  }

  static contextType = CountryContext;
  handleClickSiteSelect = () => {
    this.setState({
      siteSelect: {
        selectOpen: !this.state.siteSelect.selectOpen
      },
      hoverOptions: -1,
      dropdownOpen: false
    });
  };
  openCart = () => {
    window.scrollTo({ top: 0 });
    const body = window.document.getElementsByTagName('body')[0];
    body.addEventListener('touchmove', preventDefaultHandler, {
      passive: false
    });
    this.setState({ cartOpen: true });
  };

  closeCart = () => {
    this.setState({ cartOpen: false });
    const body = window.document.getElementsByTagName('body')[0];
    body.removeEventListener('touchmove', preventDefaultHandler);
  };

  openSubMenu(i) {
    const { selected } = this.state;
    if (selected !== i) {
      this.setState({ selected: i });
    } else {
      this.setState({ selected: -1 });
    }
  }
  toggleMenu = () => {
    const { open } = this.state;
    this.setState({
      selected: open ? -1 : this.state.selected,
      open: !open,
      siteSelect: {
        selectOpen: false
      }
    });
  };
  UNSAFE_componentWillReceiveProps(newProps) {
    const oldProps = this.props;
    if (oldProps.slug !== newProps.slug) {
      this.setState({ open: false });
      this.setState({ selected: -1 });
    }
  }

  render() {
    const {
      typeColor,
      data,
      countrySite,
      slug,
      t,
      isAuthenticated,
      white,
      sites,
      isDental,
      countries,
      activeRegion
    } = this.props;
    const {
      open,
      selected,
      cartOpen,
      siteSelect: { selectOpen }
    } = this.state;
    const { path, storePage } = this.context;
    const visibleData = data.filter(menuItem => menuItem.visible);
    return (
      <Fragment>
        <Helmet>
          <body styleName={open ? 'bodyMobileMenuOpen' : null} />
        </Helmet>
        <div styleName="logo-link">
          <Link to={path}>
            <Picture
              largeImage={pickLogo(typeColor)}
              lazyload={false}
              alt={t('Formlabs Logo')}
            />
          </Link>
        </div>
        {storePage && (
          <Fragment>
            <div styleName="store-button">
              <StoreButton
                mobile
                color={typeColor}
                openCart={this.openCart}
                closeCart={this.closeCart}
                isExternalCartOpen={cartOpen}
              />
            </div>
            <div styleName={classnames('cart-holder', { open: cartOpen })}>
              {cartOpen && (
                <div styleName="cart">
                  <div styleName="cart-inner">
                    <Cart />
                  </div>
                  <InteractiveDiv
                    handler={this.closeCart}
                    styleName="cart-close"
                  >
                    <span styleName="cart-close-icon">
                      <i className="fl-navigate_next" />
                    </span>
                    <span styleName="cart-close-text">{t('Hide cart')}</span>
                  </InteractiveDiv>
                </div>
              )}
            </div>
          </Fragment>
        )}
        <InteractiveDiv
          styleName={`hamburger ${open ? 'open' : ''} ${
            typeColor && !open
              ? `${typeColor}-nav`
              : white
              ? 'black-nav'
              : 'white-nav'
          }`}
          handler={this.toggleMenu}
          aria-label={t('mobile menu toggle')}
        >
          <span />
          <span />
          <span />
          <span />
        </InteractiveDiv>
        <div
          styleName={classnames('mobile-menu', {
            'mobile-open': open,
            'mobile-white': white
          })}
        >
          <div styleName="mobile-menu-logo">
            <Link to="/">
              <Picture
                largeImage={pickLogo(white ? 'black' : 'white')}
                lazyload={false}
                alt={t('Formlabs Logo')}
              />
            </Link>
            {isDental && (
              <Fragment>
                <SiteSelector
                  open={selectOpen}
                  sites={sites}
                  handleHoverSiteSelect={this.handleHoverSiteSelect}
                  handleClickSiteSelect={this.handleClickSiteSelect}
                />
                {selectOpen && <div styleName="mobile-overlay" />}
              </Fragment>
            )}
          </div>
          {visibleData.map((menuItem, i) => {
            const visibleChildren = menuItem.children.filter(
              child => child.visible
            );
            return (
              <div key={`main-menu-div-${i}`}>
                {visibleChildren.length >= 1 && (
                  <div
                    styleName={`main-menu-item-mobile ${
                      i === selected ? 'selected' : ''
                    } ${selected >= 0 ? 'submenu-opened' : ''}`}
                  >
                    <button
                      id={i}
                      styleName={`top-level-mobile-menu ${
                        visibleChildren.length > 0 ? 'has-children' : ''
                      }`}
                      onClick={() => this.openSubMenu(i)}
                    >
                      {menuItem.name}
                      {visibleChildren.length > 0 && (
                        <i className="fl-navigate_next" />
                      )}
                    </button>
                    <div styleName="second-level">
                      {visibleChildren.map((menuItem, i) => {
                        const link = {
                          to: menuItem.url,

                          onClick: slug
                            ? slug.pathname === menuItem.url
                              ? this.toggleMenu
                              : ''
                            : ''
                        };
                        return (
                          <div styleName={``} key={`main-menu-div-${i}`}>
                            <Link
                              {...link}
                              styleName={`second-level-mobile-menu ${
                                visibleChildren.length > 0 ? 'has-children' : ''
                              }`}
                            >
                              {menuItem.name}
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {visibleChildren.length === 0 && (
                  <div
                    styleName={`main-menu-item-mobile ${
                      i === selected ? 'selected' : ''
                    } ${selected >= 0 ? 'submenu-opened' : ''}`}
                    key={`main-menu-div-${i}`}
                  >
                    <Link to={menuItem.url}>{menuItem.name}</Link>
                  </div>
                )}
              </div>
            );
          })}
          <div key={`main-menu-div`}>
            <div
              styleName={`main-menu-item-mobile ${
                selected >= 0 ? 'submenu-opened' : ''
              }`}
            >
              <span styleName={`top-level-mobile-menu`}>
                <Link to="/dashboard">
                  {isAuthenticated ? t('Dashboard') : t('Sign In')}
                </Link>
              </span>
            </div>
          </div>
          <div styleName="mobile-buttons">
            <Grid direction="x">
              <Cell smallSize={12} backgroundColor="blue">
                {storePage && (
                  <Link to={storePage} style={white ? { color: '#fff' } : {}}>
                    {t('Store')}
                  </Link>
                )}
              </Cell>
              <Cell
                smallSize={12}
                backgroundColor={white ? 'light-grey' : 'dark-grey'}
                contentAlignment="align-children-middle"
                styleName="change-region-cell"
              >
                <CountrySelectionModal countries={countries}>
                  <div styleName="change-region">
                    <RegionFlag
                      region={activeRegion}
                      fallback={countrySite.regionFlag}
                      size={22}
                    />{' '}
                    <p>{t('Change Region')}</p>
                  </div>
                </CountrySelectionModal>
              </Cell>
            </Grid>
          </div>
        </div>
      </Fragment>
    );
  }
}
